import { yodaAgentConstants } from "../constants";

const agentReducer = (
  state = {
    loading: false,
    agents: [],
    agent: null,
  },
  action,
) => {
  switch (action.type) {
    case yodaAgentConstants.GETAGENT_ALL_REQUEST:
      return {
        ...state,
        loading: true,
        agents: [],
      };

    case yodaAgentConstants.GETAGENT_ALL_SUCCESS:
      return {
        ...state,
        agents: action.payload.agents,
        loading: false,
      };

    case yodaAgentConstants.GETAGENT_ALL_FAILURE:
      return {
        ...state,
        error: action.payload.error,
        loading: false,
      };

    case yodaAgentConstants.GETAGENT_ONE_REQUEST:
      return {
        ...state,
        loading: true,
        agent: null,
      };

    case yodaAgentConstants.GETAGENT_ONE_SUCCESS:
      return {
        ...state,
        agent: action.payload.agent,
        loading: false,
      };

    case yodaAgentConstants.GETAGENT_ONE_FAILURE:
      return {
        ...state,
        agent: null,
        error: action.payload.error,
        loading: false,
      };

    default:
      return state;
  }
};

export default agentReducer;
